export default __webpack_public_path__ + "static/img-triple-crown-point-third-6c02c7e8fe22c829b6602a44eb864af2.avif";